import { formatPence } from "../lib/money";
import { demoPurchase, portfolioTotals, useAppState } from "../lib/store";
import { ActivityFeed } from "./ActivityFeed";
import { VirtualCard } from "./VirtualCard";

export function HomeScreen() {
  const s = useAppState();
  const totals = portfolioTotals(s.roundups, s.settings.stockSymbol, s.settings.currency);
  const reserveLow = s.reservePence < 300;

  return (
    <div className="screen">
      <h1>Florin</h1>
      <p className="sub">Spend normally. Invest the change.</p>
      <VirtualCard />

      <div className="balances">
        <div className="balance-tile hero">
          <div className="balance-label">Total invested · {s.settings.stockSymbol}</div>
          <div className="balance-value accent">{formatPence(totals.investedPence, s.settings.currency)}</div>
          {totals.pendingPence > 0 && (
            <div className="balance-note">
              +{formatPence(totals.pendingPence, s.settings.currency)} queued to invest
            </div>
          )}
        </div>
        <div className="balance-tile">
          <div className="balance-label">Round-up reserve</div>
          <div className="balance-value">{formatPence(s.reservePence, s.settings.currency)}</div>
        </div>
        <div className="balance-tile">
          <div className="balance-label">Round-ups</div>
          <div className="balance-value">{totals.count}</div>
        </div>
      </div>

      {reserveLow && (
        <div className="notice" style={{ marginTop: 12 }}>
          Your round-up reserve is running low. Top it up in Settings so round-ups keep investing.
        </div>
      )}

      {s.settings.demoMode && (
        <div style={{ marginTop: 14 }} className="row">
          <button className="btn-primary" onClick={() => void demoPurchase()} disabled={s.executing}>
            Simulate card purchase
          </button>
          <button className="btn-secondary" onClick={() => void demoPurchase(true)} disabled={s.executing}>
            £3.42 coffee
          </button>
        </div>
      )}

      <h2>Activity</h2>
      <ActivityFeed roundups={s.roundups} />
    </div>
  );
}
